export const CORE_LOGIN_START = 'CORE_LOGIN_START';
export const CORE_LOGIN_SUCCESS = 'CORE|LOGIN_SUCCESS';
export const CORE_LOGIN_FAIL = 'CORE|LOGIN_FAIL';

export const CORE_LOGOUT_START = 'CORE|LOGOUT_START';
export const CORE_LOGOUT_SUCCESS = 'CORE|LOGOUT_SUCCESS';
export const CORE_LOGOUT_FAIL = 'CORE|LOGOUT_FAIL';

export const CORE_SET_ACTIVE_CUSTOMER_START = 'CORE|CORE_SET_ACTIVE_CUSTOMER_START';
export const CORE_SET_ACTIVE_CUSTOMER_SUCCESS = 'CORE|CORE_SET_ACTIVE_CUSTOMER_SUCCESS';
export const CORE_SET_ACTIVE_CUSTOMER_FAIL = 'CORE|CORE_SET_ACTIVE_CUSTOMER_FAIL';

export const CHANGE_LOGGED_USER_INFORMATION_START = 'CORE|CHANGE_LOGGED_USER_INFORMATION_START';
export const CHANGE_LOGGED_USER_INFORMATION_SUCCESS = 'CORE|CHANGE_LOGGED_USER_INFORMATION_SUCCESS';
export const CHANGE_LOGGED_USER_INFORMATION_FAIL = 'CORE|CHANGE_LOGGED_USER_INFORMATION_FAIL';

export const CORE_AUTH_SAVE_FILTER_START = 'CORE|SAVE_COLUMNS_FILTER_START';
export const CORE_AUTH_SAVE_FILTER_SUCCESS = 'CORE|SAVE_COLUMNS_FILTER_SUCCESS';
export const CORE_AUTH_SAVE_FILTER_FAIL = 'CORE|SAVE_COLUMNS_FILTER_FAIL';

export const UPDATE_TRANSLATIONS = 'UPDATE_TRANSLATIONS';
export const UPDATE_USER_STORAGE = 'UPDATE_USER_STORAGE';

export const HANDLE_ACTIVE_WAREHOUSE = 'HANDLE_ACTIVE_WAREHOUSE';

export const USER_CHANGE_PASSWORD_START = 'USER|USER_PASSWORD_CHANGE_START';
export const USER_CHANGE_PASSWORD_SUCCESS = 'USER|USER_PASSWORD_CHANGE_SUCCESS';
export const USER_CHANGE_PASSWORD_FAIL = 'USER|USER_PASSWORD_CHANGE_FAIL';
export const SET_DEFAULT_TRANSLATION = "TRANSLATE|SET_DEFAULT_TRANSLATION";

export const USER_SESSION_EXPIRED = 'USER|SESSION_EXPIRED';
export const USER_SESSION_EXTENDED =  'USER|SESSION_EXTENDED';
